/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ColorObject, getColor } from 'jotai/vehicleColor';
import { LocalVehicleSelectionsPerformance } from './LocalVehicleSelectionsObject';

const performanceColors: Record<LocalVehicleSelectionsPerformance, ColorObject> = {
  leaders: getColor('9', 'vehicle') as ColorObject,
  currentFastestDriver: getColor('17', 'vehicle') as ColorObject,
  luckyDog: getColor('10', 'vehicle') as ColorObject,
};

export const getPerformanceColor = (performance: LocalVehicleSelectionsPerformance): ColorObject => {
  return { ...performanceColors[performance] };
};
